import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout/index.vue'
export const asyncRoutes = []
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录', show: false, keepAlive: true },
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/home',
    component: () => import('@/views/dashboard/index.vue'),
    name: 'home',
    meta: { title: '可视化分析', enTitle: 'home', show: false }
  },
  // {
  //   path: '/login1',
  //   name: 'Login1',
  //   meta: { title: '登录', show: false, keepAlive: true },
  //   component: () => import('@/views/login/index1.vue')
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    meta: { title: '可视化分析', enTitle: 'home', show: false },
    children: [
      {
        path: 'home',
        component: () => import('@/views/dashboard/index.vue'),
        name: 'home',
        meta: { title: '可视化分析', enTitle: 'home', icon: 'dashboard', affix: true, show: true }
      }

    ]

  }

]

const router = createRouter({
  history: createWebHashHistory(),
  routes: constantRoutes
})

export default router
